import {ITrailerJson} from "../../../../../nodeserver/structs/database";
import JSX from "../../helpers/react.js";
import {TrailerButton} from "./TrailerButton.js";
import {VideoPlayerIframe} from "./VideoPlayerIframe.js";
import RefObject = JSX.RefObject;

export function TrailerBlockContent({trailers}: {trailers: ITrailerJson[]}){

    const iframe: RefObject<HTMLIFrameElement> = {};
    const btnRefs: RefObject<HTMLElement>[] = trailers.map(()=>({}));
    if(!trailers.length){
        return <NothingFound />
    }
    if(trailers.length > 1) {
        const ans =  (
            <div className="episodes-container">
                <div className="episodes custom-scroll">
                    <div className="block-episodes show">
                        {
                            ...trailers.map(
                                (e, index) => (
                                    <TrailerButton onClick={url=>changeIframeUrl(url, index)} url={e.iframe_url} title={e.number} ref={btnRefs[index]}/>
                                )
                            )
                        }
                    </div>
                </div>
                <VideoPlayerIframe iframeRef={iframe}/>
            </div>
        )
        changeIframeUrl(trailers[0].iframe_url, 0);
        return ans;
        function changeIframeUrl(url: string, index: number) {
            iframe.value!.src = url;
            for(const el of btnRefs) el.value!.classList.remove('active');
            btnRefs[index].value!.classList.add('active');
        }
    }
    else{
        return (
            <VideoPlayerIframe iframeRef={iframe} src={trailers[0].iframe_url}/>
        )
    }
}

function NothingFound(){
    return (
        <div className="error-notification status-bg alert-bg bordered">Трейлеров пока нет</div>
    )
}